export default __webpack_public_path__ + "1abdd805b41876db09853aec0cee64b3.svg";